﻿"use strict";

window.activateControlEnter = function (submitButtonId) {
	var map = {
		13: false,	// Enter
		16: false,	// Shift
		17: false	// Ctrl
	};
	$(document).keydown(function (e) {
		if (e.keyCode in map) {
			map[e.keyCode] = true;
			if (map[17] && map[13]) {	// Ctrl and Enter are pressed
				$('input').each(function () {
					$(this).trigger('blur');
					//each input event is blurred, i.e. given the info that it has lost focus
					//this is important, because otherwise the on event is not triggered and the 
					//autoCalculateLanding/Takeoff is not executed
				});
				// button groups behave strange in conjunction with focus, maybe we have to use this later, currently focus is not set.
				//$('.btn-group').children().each(function () {
				//	$(this).trigger('blur');
				//	//each input event is blurred, i.e. given the info that it has lost focus
				//	//this is important, because otherwise the on event is not triggered and the 
				//	//autoCalculateLanding/Takeoff is not executed
				//});

				if (map[16]) {	// Shift is also pressed
					wizardPrevPage(false);
				} else {
					if (submitButtonId.length > 0) {
						doNotWarnOnPageLeave();
						document.getElementById(submitButtonId).click();
					} else {
						wizardNextPage(false);
					}
				}
			}
		}
	}).keyup(function (e) {
		if (e.keyCode in map) {
			map[e.keyCode] = false;
		}
	});
};

window.onsubmit_preventDoubleClick_IconButtons = function (formId) {
	var form = $('#' + formId);
	if (form.valid()) {
		var submitButton = form.find('button[type="Submit"]')[0];
		if (submitButton) {
			submitButton.disabled = true; // disable the hidden button (used with icon buttons) to prevent double clicks
		}
	}
};